import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../components/button'
import { PageContainer } from '../../../../components/page-container/page-container'
import { paths } from '../../../../router/paths'
import { createCollectionOrderReset } from '../../presentation/redux/actions/create-collection-order-actions'
import { getCollectionOrderStatusReset } from '../../presentation/redux/actions/get-collection-order-status-actions'
import type { RootState } from '../../../../redux/global-store'
import PrintReceiptModal from '../../../../components/print-receipt-modal/print-receipt-modal'
import React from 'react'

export const AchReceived = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [openPrintModal, setOpenPrintModal] = React.useState(false)

  // ID retornado quando a ordem foi criada (assumindo slice createCollectionOrder)
  const createdCollectionOrderId = useSelector(
    (state: RootState) =>
      state.createCollectionOrder.createCollectionOrder?.data,
  )

  const handleResetFlow = () => {
    dispatch(createCollectionOrderReset())
    dispatch(getCollectionOrderStatusReset())
    navigate(paths.home)
  }

  return (
    <PageContainer type="authenticated">
      <div className="bg-primary-darkest flex w-full items-center justify-center px-4 py-4">
        <p className="max-w-[620px] text-center text-[24px] leading-tight font-bold text-white">
          Transferencia ACH recibida
        </p>
      </div>
      <div className="flex w-full flex-col items-center px-6 pt-24 pb-12">
        <div className="flex w-full max-w-[420px] flex-col items-center gap-20">
          <div className="flex justify-center py-2">
            <img
              src={
                'https://storage.googleapis.com/osb-files/dash/logo-primary.png'
              }
              alt="logo"
              className="w-50 object-cover"
            />
          </div>
          <div className="mt-10 flex w-full flex-col items-center gap-6 pt-30">
            <Button
              className="h-[55px] w-full max-w-[450px] rounded-[10px] text-base font-semibold"
              disabled={!createdCollectionOrderId}
              onClick={() => setOpenPrintModal(true)}
            >
              Imprimir voucher de la venta
            </Button>
            <Button
              variant="outlined"
              className="h-[55px] w-full max-w-[450px] rounded-[10px] text-base font-semibold"
              onClick={() => handleResetFlow()}
            >
              Regresar
            </Button>
          </div>
        </div>
      </div>
      <PrintReceiptModal
        isOpen={openPrintModal}
        onClose={() => setOpenPrintModal(false)}
        type="collection-order"
        data={
          createdCollectionOrderId
            ? { CollectionOrderId: createdCollectionOrderId }
            : null
        }
      />
    </PageContainer>
  )
}
